import React from 'react';
//import './ChatChip.css';

const ChatChip = ({ text, onClick, disabled = false, stacked = false }) => {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (disabled) return;
        
        onClick?.(text);
    };

    return (
        <button
            className={`chat-chip ${stacked ? 'chat-chip-stacked' : ''} ${disabled ? 'chat-chip-disabled' : ''}`}
            data-chip-text={text}
            onClick={handleClick}
            disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            title={disabled ? '' : text}
            aria-disabled={disabled}
            onKeyDown={(e) => {
                if (disabled) return;
                if (e.key === 'Enter' || e.key === ' ') {
                    handleClick(e);
                }
            }}
        >
            {stacked && <span className="chip-arrow">→</span>}
            <span className="chip-text">{text}</span>
        </button>
    );
};

export default ChatChip;